import validator from 'validator'

import {
  normalizeBooleanValue,
  normalizeIntValue,
  normalizeStringValue,
  normalizeValueAsIntArray,
} from '../../../../../helpers/normalizers'

import areasOfKnowledge from '../options/areas_of_knowledge.json'
import ongAreas from '../options/ong_areas.json'
import availabilityPeriods from '../options/availability_periods.json'
import profiles from '../options/profiles.json'

export default {
  applicant_name: {
    label: 'Nome completo *',
    initialValue: '',
    parseRegistration(registrationData) {
      return normalizeStringValue(registrationData.full_name)
    },
    validate(fieldId, formData) {
      if (validator.isEmpty(formData[fieldId])) {
        return { [fieldId]: 'blank' }
      }
      return {}
    },
  },
  applicant_email: {
    label: 'E-mail *',
    initialValue: '',
    parseRegistration(registrationData) {
      return normalizeStringValue(registrationData.email)
    },
    validate(fieldId, formData) {
      if (validator.isEmpty(formData[fieldId])) {
        return { [fieldId]: 'blank' }
      }
      if (!validator.isEmail(formData[fieldId])) {
        return { [fieldId]: 'invalid' }
      }
      return {}
    },
  },
  applicant_phone_number: {
    label: 'Telefone *',
    initialValue: '',
    parseRegistration(registrationData) {
      return normalizeStringValue(
        registrationData.extra_data.applicant_phone_number,
      )
    },
    validate(fieldId, formData) {
      if (validator.isEmpty(formData[fieldId])) {
        return { [fieldId]: 'blank' }
      }
      return {}
    },
  },
  applicant_profile: {
    label: 'Qual seu perfil? *',
    initialValue: '',
    options: profiles,
    parseRegistration(registrationData) {
      return normalizeIntValue(registrationData.extra_data.applicant_profile)
    },
    validate(fieldId, formData) {
      if (validator.isEmpty(formData[fieldId])) {
        return { [fieldId]: 'blank' }
      }
      return {}
    },
  },
  applicant_profile_other: {
    label: 'Informe qual *',
    initialValue: '',
    parseRegistration(registrationData) {
      return normalizeStringValue(
        registrationData.extra_data.applicant_profile_other,
      )
    },
    validate(fieldId, formData) {
      if (String(formData.applicant_profile) === '1') {
        if (validator.isEmpty(formData[fieldId])) {
          return { [fieldId]: 'blank' }
        }
      }
      return {}
    },
  },
  applicant_company: {
    label: 'Empresa *',
    initialValue: '',
    parseRegistration(registrationData) {
      return normalizeStringValue(registrationData.extra_data.applicant_company)
    },
    validate(fieldId, formData) {
      if (String(formData.applicant_profile) === '5') {
        if (validator.isEmpty(formData[fieldId])) {
          return { [fieldId]: 'blank' }
        }
      }
      return {}
    },
  },
  applicant_company_area: {
    label: 'Qual o público de atuação da ONG? *',
    initialValue: '',
    options: ongAreas,
    parseRegistration(registrationData) {
      return normalizeIntValue(
        registrationData.extra_data.applicant_company_area,
      )
    },
    validate(fieldId, formData) {
      if (String(formData.applicant_profile) === '6') {
        if (validator.isEmpty(formData[fieldId])) {
          return { [fieldId]: 'blank' }
        }
      }
      return {}
    },
  },
  applicant_company_area_other: {
    label: 'Informe qual *',
    initialValue: '',
    parseRegistration(registrationData) {
      return normalizeStringValue(
        registrationData.extra_data.applicant_company_area_other,
      )
    },
    validate(fieldId, formData) {
      if (String(formData.applicant_profile) === '6') {
        if (String(formData.applicant_company_area) === '1') {
          if (validator.isEmpty(formData[fieldId])) {
            return { [fieldId]: 'blank' }
          }
        }
      }
      return {}
    },
  },
  applicant_area_of_knowledge: {
    label:
      'Qual sua área de conhecimento que poderá colaborar? Escolha até 3 opções: *',
    initialValue: [],
    options: areasOfKnowledge,
    parseRegistration(registrationData) {
      return normalizeValueAsIntArray(
        registrationData.extra_data.applicant_area_of_knowledge,
      )
    },
    validate(fieldId, formData) {
      if (!Array.isArray(formData[fieldId]) || formData[fieldId].length <= 0) {
        return { [fieldId]: 'blank' }
      }
      return {}
    },
  },
  applicant_area_of_knowledge_other: {
    label: 'Informe qual *',
    initialValue: '',
    parseRegistration(registrationData) {
      return normalizeStringValue(
        registrationData.extra_data.applicant_area_of_knowledge_other,
      )
    },
    validate(fieldId, formData) {
      if (formData.applicant_area_of_knowledge.map(String).indexOf('1') >= 0) {
        if (validator.isEmpty(formData[fieldId])) {
          return { [fieldId]: 'blank' }
        }
      }
      return {}
    },
  },
  applicant_availability: {
    label:
      'Considerando sua agenda, indique os horários de sua disponibilidade para mentorias:',
    initialValue: [],
    options: availabilityPeriods,
    parseRegistration(registrationData) {
      return normalizeValueAsIntArray(
        registrationData.extra_data.applicant_availability,
      )
    },
    validate(fieldId, formData) {
      if (!Array.isArray(formData[fieldId]) || formData[fieldId].length <= 0) {
        return { [fieldId]: 'blank' }
      }
      return {}
    },
  },
  accepts_mailing: {
    label:
      'Concordo em receber informações sobre este hackathon por e-mail e telefone.',
    initialValue: false,
    parseRegistration(registrationData) {
      return normalizeBooleanValue(registrationData.extra_data.accepts_mailing)
    },
    validate(fieldId, formData) {
      if (!formData[fieldId]) {
        return { [fieldId]: 'blank' }
      }
      return {}
    },
  },
  accepts_marketing: {
    label: 'Concordo em receber informações sobre outros eventos de inovação.',
    initialValue: false,
    parseRegistration(registrationData) {
      return normalizeBooleanValue(
        registrationData.extra_data.accepts_marketing,
      )
    },
  },
  accepts_terms_of_use: {
    label: 'Concordo com os termos de uso e a Política de Privacidade.',
    initialValue: false,
    parseRegistration(registrationData) {
      return normalizeBooleanValue(
        registrationData.extra_data.accepts_terms_of_use,
      )
    },
    validate(fieldId, formData) {
      if (!formData[fieldId]) {
        return { [fieldId]: 'blank' }
      }
      return {}
    },
  },
}
